export const SpeedIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M55.3546 45.0476C56.3973 41.1582 56.5313 37.0811 55.7462 33.1316C54.961 29.1822 53.2778 25.4663 50.8267 22.2715C48.3756 19.0767 45.2223 16.4886 41.6109 14.7075C37.9995 12.9264 34.0267 12 30 12C25.9733 12 22.0005 12.9264 18.3891 14.7075C14.7777 16.4886 11.6244 19.0767 9.17333 22.2715C6.72224 25.4663 5.039 29.1822 4.25384 33.1316C3.46868 37.0811 3.60266 41.1582 4.64542 45.0476"
                stroke="url(#paint0_linear_368_3064)" strokeWidth="4" strokeLinecap="round"/>
            <path
                d="M32.2334 39.9493C33.6538 42.0201 32.6534 45.176 29.9992 46.9989C27.3451 48.8247 24.0405 48.6264 22.6201 46.5585C21.1034 44.3535 15.8709 31.9547 12.6946 24.2839C12.0967 22.8401 13.8613 21.6268 14.9988 22.703C21.0188 28.4197 30.7196 37.7443 32.2334 39.9493Z"
                stroke="url(#paint1_linear_368_3064)" strokeWidth="4"/>
            <path
                d="M29.9991 12.0018V17.8351M11.4374 19.6901L15.5616 23.8143M48.5608 19.6901L44.4366 23.8143M55.3537 45.0476L49.7216 43.5368M4.64453 45.0476L10.2766 43.5368"
                stroke="url(#paint2_linear_368_3064)" strokeWidth="4" strokeLinecap="round"/>
            <defs>
                <linearGradient id="paint0_linear_368_3064" x1="33.6207" y1="-6.46779" x2="68.2112" y2="79.3351"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_368_3064" x1="24.1271" y1="7.78593" x2="62.5296" y2="54.6924"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint2_linear_368_3064" x1="33.4963" y1="-6.465" x2="68.9489" y2="78.4811"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};